import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/landing.css';

/**
 * Placeholder Privacy Policy — not legal advice; content to be finalized.
 */
const Privacy: React.FC = () => {
  return (
    <div className="landing-legal">
      <a href="#legal-main" className="landing-skip">
        Skip to main content
      </a>
      <header className="landing-legal__header">
        <Link to="/" className="landing-brand">
          <span className="landing-brand__mark" aria-hidden="true">
            <svg viewBox="0 0 20 20" fill="currentColor" className="h-5 w-5">
              <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zm0 10a2 2 0 11-.001-3.999A2 2 0 0110 12z" />
            </svg>
          </span>
          <span className="landing-brand__text">Winery</span>
        </Link>
        <Link to="/login" className="landing-btn landing-btn--primary landing-btn--sm">
          Sign in
        </Link>
      </header>

      <main id="legal-main" className="landing-legal__main">
        <p className="landing-legal__banner" role="note">
          This page is a placeholder summary and is not legal advice. Final privacy terms will be
          published before production use. Last updated: July 11, 2026.
        </p>

        <h1>Privacy Policy</h1>
        <p>
          Wine Management System (“we”, “the Service”) helps winery teams manage production data.
          This outline describes how we intend to handle information when the Service is used.
        </p>

        <h2>Information we process</h2>
        <p>
          Depending on how your organization configures the Service, we may process account details
          (such as name and email), authentication data, and winery operational records you enter
          (for example vineyards, batches, vessels, inventory, and related logs).
        </p>

        <h2>How we use information</h2>
        <p>
          We use information to provide and secure the Service, authenticate users, support your
          organization&apos;s administrators, improve reliability, and comply with applicable law.
          We do not sell personal information.
        </p>

        <h2>Access and accounts</h2>
        <p>
          Access is invite-only. Your organization&apos;s administrators control who receives an
          account and what permissions they have. Contact your administrator for access, correction,
          or deletion requests related to your user profile within the Service.
        </p>

        <h2>Retention and security</h2>
        <p>
          We retain information as needed to operate the Service and meet legal obligations.
          We apply reasonable technical and organizational measures to protect data; no method of
          transmission or storage is completely secure.
        </p>

        <h2>Contact</h2>
        <p>
          A dedicated privacy contact will be listed here when available. Until then, reach your
          organization&apos;s administrator for account-related privacy requests.
        </p>

        <p>
          <Link to="/">Back to home</Link>
          {' · '}
          <Link to="/terms">Terms of Service</Link>
        </p>
      </main>
    </div>
  );
};

export default Privacy;
